import { bootstrapApplication } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { Capacitor } from '@capacitor/core';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from '#services/auth/auth.interceptor';
import { PurchaseService } from '#services/purchase/purchase.service';
import { PurchaseWebService } from '#services/purchase/purchase.web.service';
import { SubscriptionService } from '#services/subscription/subscription.service';
import { SubscriptionWebService } from '#services/subscription/subscription.web.service';
import { StaleBundleErrorHandler } from '#services/app-reload/stale-bundle-error.handler';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: StaleBundleErrorHandler },
    importProvidersFrom(
      IonicModule.forRoot({
        innerHTMLTemplatesEnabled: true,
      })
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: PurchaseService,
      useClass: Capacitor.isNativePlatform() ? PurchaseService : PurchaseWebService,
    },
    {
      provide: SubscriptionService,
      useClass: Capacitor.isNativePlatform() ? SubscriptionService : SubscriptionWebService,
    },
  ],
});
